/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import DateUtil from '../utils/DateUtil';
import {TSSchadenArt} from './enums/TSSchadenArt';
import {TSVersicherungsbeitragStatus} from './enums/TSVersicherungsbeitragStatus';
import TSGemeinde from './TSGemeinde';
import {TSSerializable} from './TSSerializable';
import moment = require('../../../node_modules/moment/moment');

export default class TSVersicherungsbeitragDTO {

    private _versicherungsbeitragId: string;
    private _versicherungName: string | undefined;
    private _policeNummer: string | undefined;
    private _betrag: number;
    private _externalSchadenNr: string;
    private _schadendatum: moment.Moment | undefined;
    private _status: TSVersicherungsbeitragStatus;
    private _schadenArt: TSSchadenArt;
    private _gemeinde: TSGemeinde | undefined;

    public get schadendatum(): moment.Moment | undefined {
        return this._schadendatum;
    }

    public set schadendatum(value: moment.Moment | undefined) {
        this._schadendatum = value;
    }

    public get status(): TSVersicherungsbeitragStatus {
        return this._status;
    }

    public set status(value: TSVersicherungsbeitragStatus) {
        this._status = value;
    }

    public get policeNummer() {
        return this._policeNummer;
    }

    public set policeNummer(value) {
        this._policeNummer = value;
    }

    public get externalSchadenNr(): string {
        return this._externalSchadenNr;
    }

    public set externalSchadenNr(value: string) {
        this._externalSchadenNr = value;
    }

    public get schadenArt(): TSSchadenArt {
        return this._schadenArt;
    }

    public set schadenArt(value: TSSchadenArt) {
        this._schadenArt = value;
    }

    public get gemeinde(): TSGemeinde | undefined {
        return this._gemeinde;
    }

    public set gemeinde(value: TSGemeinde | undefined) {
        this._gemeinde = value;
    }

    public get versicherungsbeitragId(): string {
        return this._versicherungsbeitragId;
    }

    public set versicherungsbeitragId(value: string) {
        this._versicherungsbeitragId = value;
    }

    public get betrag(): number {
        return this._betrag;
    }

    public set betrag(value: number) {
        this._betrag = value;
    }

    public get versicherungName(): string | undefined {
        return this._versicherungName;
    }

    public set versicherungName(value: string | undefined) {
        this._versicherungName = value;
    }

    deserialize(restObject: any): TSVersicherungsbeitragDTO {
        this.versicherungsbeitragId = restObject.versicherungsbeitragId;
        this.externalSchadenNr = restObject.externalSchadenNr;
        this.schadenArt = restObject.schadenArt;
        this.schadendatum = DateUtil.localDateToMoment(restObject.schadendatum);
        this.status = restObject.status;
        this.policeNummer = restObject.policeNummer;
        this.gemeinde = this.deserializeOrNull(restObject.gemeinde, new TSGemeinde());
        this.betrag = restObject.betrag;
        this.versicherungName = restObject.versicherungName;
        return this;
    }

    public deserializeOrNull<T extends TSSerializable<any>>(restObject: any, obj: T): T | undefined {
        if (restObject) {
            return obj.deserialize(restObject);
        } else {
            return undefined;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSVersicherungsbeitragDTO.ts